import {
	getPlayersJsonSuccess,
	getPlayersSuggestedJsonSuccess,
	resetSearchPlayer,
	setSearchPlayer, getPlayersSelectedJsonSuccess,
} from 'modules/actions/players';
import {PoolTabsType} from "modules/enums";
import {createReducer} from "redux-act";

type TPlayersStore = ReturnType<typeof getPlayersJsonSuccess>["payload"] &
	ReturnType<typeof getPlayersSelectedJsonSuccess>["payload"] &
	ReturnType<typeof getPlayersSuggestedJsonSuccess>["payload"] & {search: string};

const defaultState: TPlayersStore = {
	players: {},
	allActivePlayers: {},
	poolPlayers: {
		[PoolTabsType.FAVORITE]: [],
		[PoolTabsType.CLUB]: [],
		[PoolTabsType.SUGGESTED]: [],
		[PoolTabsType.POPULAR]: [],
		[PoolTabsType.HOT_PICKS]: [],
	},
	suggestedPlayers: [],
	mostSelectedPlayers: [],
	search: "",
};

export const players = createReducer({}, defaultState);

players.on(getPlayersJsonSuccess, (state, payload) => ({
	...state,
	...payload,
}));

players.on(getPlayersSuggestedJsonSuccess, (state, payload) => ({
	...state,
	...payload,
}));

players.on(getPlayersSelectedJsonSuccess, (state, payload) => ( {
	...state,
	mostSelectedPlayers: payload.mostSelectedPlayers,
} ));

players.on(setSearchPlayer, (state, payload) => ({
	...state,
	...payload,
}));
players.on(resetSearchPlayer, (state) => ({
	...state,
	search: defaultState.search,
}));
